import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const DovecoteTower = {
  id: "67",
  name: "Dovecote Tower",
  width: 3,
  height: 2,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Dovecote_Tower",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Dovecote_Tower',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RANGED_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        1.00, 1.00, 1.00, 1.75, 1.75, 1.75, 2.50, 2.50, 2.50, 2.50,
        2.50, 3.25, 3.25, 3.25, 3.25, 4.00, 4.00, 4.00, 4.00, 4.75,
        4.75, 4.75, 4.75, 5.50, 5.50, 5.50, 5.50, 6.25, 6.25, 6.25,
        7.00, 7.00, 7.00, 7.00, 7.75, 7.75, 7.75, 7.75, 8.50, 8.58,
        8.67, 8.75, 8.83, 8.92, 9.00, 9.08, 9.17, 9.25, 9.33, 9.42,
        9.50, 9.58, 9.67, 9.75, 9.83, 9.92, 10.00, 10.08, 10.17, 10.25
      ]),
      '%',
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          15,15,24,24,33,33,40,40,47,47,53,53,58,58,63,63,68,68,73,73,78,78,82,82,86,86,90,90,94,94,94,100,100,104,104,107,107,111,111,114,115,117,118,120,121,123,124,126,127,129,130,132,133,135,136,138,139,141,142,144
        ],
        bronzeAge: [
          20,20,43,43,59,59,72,72,84,84,95,95,105,105,114,114,123,123,132,132,140,140,148,148,155,155,163,163,170,170,170,180,180,187,187,193,193,200,200,206,209,212,215,218,221,224,227,230,233,236,239,242,245,248,251,254,257,260,263,266
        ],
        minoanEra: [
          30,30,63,63,85,85,104,104,121,121,137,137,151,151,165,165,178,178,190,190,202,202,213,213,224,224,235,235,245,245,245,260,260,270,270,279,279,288,288,297,301,306,310,315,319,324,328,333,337,342,346,351,355,360,364,369,373,378,382,387
        ],
        classicGreece: [
          40,40,82,82,112,112,137,137,159,159,179,179,198,198,216,216,233,233,249,249,264,264,279,279,293,293,307,307,320,320,320,340,340,353,353,365,365,377,377,389,395,401,407,413,419,425,431,437,443,449,455,461,467,473,479,485,491,497,503,509
        ],
        earlyRome: [
          50,50,101,101,138,138,169,169,196,196,221,221,245,245,267,267,287,287,307,307,326,326,345,345,362,362,379,379,396,396,396,420,420,436,436,451,451,466,466,480,487,494,501,508,515,522,529,536,543,550,557,564,571,578,585,592,599,606,613,620
        ],
        romanEmpire: [
          60,60,121,121,164,164,201,201,234,234,263,263,291,291,317,317,342,342,366,366,388,388,410,410,431,431,452,452,471,471,471,500,500,519,519,537,537,554,554,572,581,590,599,608,617,626,635,644,653,662,671,680,689,698,707,716,725,734,743,752
        ],
        byzantineEra: [
          70,70,140,140,190,190,233,233,271,271,306,306,338,338,368,368,397,397,424,424,450,450,476,476,500,500,524,524,547,547,547,580,580,601,601,622,622,643,643,663,673,683,693,703,713,723,733,743,753,763,773,783,793,803,813,823,833,843,853,863
        ],
        ageOfTheFranks: [
          80,80,159,159,217,217,265,265,308,308,348,348,384,384,419,419,452,452,483,483,513,513,541,541,569,569,596,596,622,622,622,660,660,684,684,708,708,732,732,755,766,778,789,801,812,824,835,847,858,870,881,893,904,916,927,939,950,962,973,985
        ],
        feudalAge: [
          90,90,178,178,242,242,296,296,344,344,388,388,429,429,467,467,504,504,538,538,572,572,604,604,635,635,665,665,694,694,694,736,736,763,763,790,790,816,816,841,853,866,878,891,903,916,928,941,953,966,978,991,1003,1016,1028,1041,1053,1066,1078,1091
        ],
        iberianEra: [
          100,100,196,196,267,267,326,326,379,379,428,428,473,473,515,515,556,556,594,594,631,631,666,666,700,700,733,733,765,765,765,812,812,842,842,871,871,900,900,928,942,956,970,984,998,1012,1026,1040,1054,1068,1082,1096,1110,1124,1138,1152,1166,1180,1194,1208
        ],
        kingdomOfSicily: [
          110,110,215,215,292,292,357,357,415,415,468,468,517,517,564,564,608,608,649,649,690,690,728,728,766,766,802,802,837,837,837,888,888,921,921,953,953,984,984,1015,1030,1046,1061,1077,1092,1108,1123,1139,1154,1170,1185,1201,1216,1232,1247,1263,1278,1294,1309,1325
        ],
        highMiddleAges: [
          120,120,234,234,318,318,389,389,452,452,510,510,564,564,615,615,663,663,707,707,752,752,794,794,835,835,874,874,912,912,912,968,968,1004,1004,1039,1039,1073,1073,1106,1123,1140,1157,1174,1191,1208,1225,1242,1259,1276,1293,1310,1327,1344,1361,1378,1395,1412,1429,1446
        ],
        earlyGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
        ]
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3,
        3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
        5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,35,35,35,35,70,70,70,70,100,100,100,100,120,120,120,120,140,140,140,140,160,160,160,160,175,175,175,175,190,190,190,200,200,200,200,215,220,224,228,231,235,239,243,247,250,254,258,262,266,269,273,277,281,285,288,292,296,300,304
        ],
        bronzeAge: [
          0,35,35,35,35,70,70,70,70,100,100,100,100,120,120,120,120,140,140,140,140,160,160,160,160,175,175,175,175,190,190,190,200,200,200,200,215,220,224,228,231,235,239,243,247,250,254,258,262,266,269,273,277,281,285,288,292,296,300,304
        ],
        minoanEra: [
          0,50,50,50,50,100,100,100,100,140,140,140,140,170,170,170,170,195,195,195,195,220,220,220,220,240,240,240,240,265,265,265,280,280,280,280,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380,385,390,395,400,405,410,415
        ],
        classicGreece: [
          0,80,80,80,80,160,160,160,160,220,220,220,220,270,270,270,270,310,310,310,310,350,350,350,350,390,390,390,390,425,425,425,450,450,450,450,483,493,501,510,518,526,534,543,551,559,568,576,584,593,601,609,617,626,634,642,651,659,667,676
        ],
        earlyRome: [
          0,100,100,100,100,200,200,200,200,270,270,270,270,330,330,330,330,380,380,380,380,430,430,430,430,480,480,480,480,520,520,520,550,550,550,550,590,600,610,620,630,640,650,660,670,680,690,700,710,720,730,740,750,760,770,780,790,800,810,820
        ],
        romanEmpire: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ],
        byzantineEra: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ],
        ageOfTheFranks: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ],
        feudalAge: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ],
        iberianEra: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ],
        kingdomOfSicily: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ],
        highMiddleAges: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ],
        earlyGothicEra: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ],
        lateGothicEra: [
          0,120,120,120,120,240,240,240,240,320,320,320,320,390,390,390,390,450,450,450,450,510,510,510,510,565,565,565,565,615,615,615,650,650,650,650,700,713,725,738,750,763,775,788,800,813,825,838,850,863,875,888,900,913,925,938,950,963,975,988
        ]
      }).withOutput(ProductionOutputType.CURRENT_ERA_PRIMARY_GOODS)
    ),
  ]),
};

export default DovecoteTower;
